<section fxLayout="column" fxLayoutGap="10px">
  <div>
    <label for="name">{{type}}: </label>
    <div *ngIf="addressLineOne" class="info-value"> <span>{{addressLineOne}},</span></div>
  </div>
  <div *ngIf="addressLineTwo" class="info-value indent"><span>{{addressLineTwo}},</span></div>
  <div *ngIf="addressLineThree" class="info-value indent"><span>{{addressLineThree}}<span *ngIf="addressLineFour">,</span></span></div>
  <div *ngIf="addressLineFour" class="info-value indent"><span>{{addressLineFour.toLocaleUpperCase()}}</span></div>
</section>
